import { render } from "./NotificationsCreateComponent.vue?vue&type=template&id=4ae6c19a"
import script from "./NotificationsCreateComponent.vue?vue&type=script&lang=js"
export * from "./NotificationsCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__